import { render, staticRenderFns } from "./LoadingFull.vue?vue&type=template&id=1b5ed856&scoped=true"
import script from "./LoadingFull.vue?vue&type=script&lang=js"
export * from "./LoadingFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5ed856",
  null
  
)

export default component.exports